/**
 * Shared client URL helpers. Centralizes the `?admin=true` parse so callers
 * (main, GameClient, InputManager) don't each reimplement it.
 */

/** True when the page was loaded with `?admin=true`. Safe to call before DOM ready. */
export function isAdminMode(): boolean {
  if (typeof window === 'undefined' || !window.location) return false;
  return new URLSearchParams(window.location.search).get('admin') === 'true';
}
